import * as React from 'react';
import {createPortal} from 'react-dom';
import {appConnectionStatus,isBundledClient} from '../util/appConnectionStatus';
import './AppConnectionStatus.css';

export function AppConnectionStatus(){
 const [native]=React.useState(isBundledClient),[phase,setPhase]=React.useState(appConnectionStatus.get);
 React.useEffect(()=>appConnectionStatus.subscribe(()=>setPhase(appConnectionStatus.get())),[]);
 if(!native||phase==='idle')return null;
 if(phase==='restored')return createPortal(<div className="app-connection-restored" role="status">การเชื่อมต่อกลับมาแล้ว</div>,document.body);
 return createPortal(<div className="app-connection-overlay" role={phase==='failed'?'alert':'status'} aria-live="polite">
  <div className="app-connection-card">
   {phase==='reconnecting'?<><span className="app-connection-spinner" aria-hidden="true"/><strong>reconnect</strong><p>กำลังเชื่อมต่อเซิฟเวอร์อีกครั้ง…</p></>:
    <p>การเชื่อมต่อเซิฟเวอร์ขาดหาย กรุณาปัดแอพทิ้ง แล้วเข้าแอพใหม่</p>}
  </div>
 </div>,document.body);
}
